import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { SelectButtonModule } from "primeng/selectbutton";

@Component({
  selector: "app-search-overlay",
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    SelectButtonModule,
    FormsModule,
    DropdownModule,
    CalendarModule,
  ],
  templateUrl: "./search-overlay.component.html",
  styleUrl: "./search-overlay.component.scss",
})
export class SearchOverlayComponent {
  router = inject(Router);

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  searchOptions: any[] = [
    { label: "Sequence", value: "Sequence" },
    { label: "Employee", value: "Employee" },
  ];

  seatOptions: any[] = [
    { label: "CA", value: "CA" },
    { label: "FO", value: "FO" },
    { label: "FB", value: "FB" },
    { label: "FC", value: "FC" },
    { label: "RC", value: "RC" },
    { label: "XA", value: "XA" },
    { label: "XO", value: "XO" },
  ];

  minDate: Date = new Date(2023, 0, 1);

  selectedSequence: number | null = null;
  selectedDate: Date | null = null;
  selectedSeat: { label: string; value: string } | null = null;

  onSearch(): void {
    if (this.selectedSequence && this.selectedDate && this.selectedSeat) {
      const date = this.selectedDate?.toLocaleDateString();
      const formatedDate = date.replace(/\//g, "-");
      this.router.navigate([
        `/history/${this.selectedSequence}/${formatedDate}/${this.selectedSeat.value}`,
      ]);
    }
    this.closeDialog();
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
